<div class="pr" style="margin-top: 10px">
    <div class='block options'>
        <div class="left bold" *ngIf="data.isAllocationGroupEquivalentsRecordsPresent && pralloc.group === 'ungroupedAllocLabel'">Group equivalents: <input type="checkbox" [(ngModel)]="pralloc.showEquivalents" (change)="setShowEquivalents()"/></div>
        <div class="left bold" *ngIf="data.isAllocationExcludedPositionRecordsPresent">Show excluded: <input type="checkbox" [(ngModel)]="pralloc.showExcluded" (change)="setShowExcluded()"/></div>
        <div class="left" *ngIf="pralloc.group === 'ACLevel'">
            <span class="bold" style="margin-right: 10px;">Asset Class Detail</span>
            <span style="margin-right: 10px;"><input type="checkbox" [(ngModel)]="pralloc.assetClassDetail1" (change)="setAssetClassDetail()"/> Level 1</span>
            <span style="margin-right: 10px;"><input type="checkbox" [(ngModel)]="pralloc.assetClassDetail2" (change)="setAssetClassDetail()"/> Level 2</span>
            <span style="margin-right: 10px;"><input type="checkbox" [(ngModel)]="pralloc.assetClassDetail3" (change)="setAssetClassDetail()"/> Level 3</span>
            <span style="margin-right: 10px;"><input type="checkbox" [(ngModel)]="pralloc.assetClassDetail4" (change)="setAssetClassDetail()"/> Level 4</span>
            <span style="margin-right: 10px; padding-left: 10px; border-left: 1px solid #CCC"><a (click)="expandAll()">Expand all</a></span>
            <span style="margin-right: 10px; padding-left: 10px; border-left: 1px solid #CCC"><a (click)="collapseAll()">Collapse all</a></span>
        </div>
        <div class="left" *ngIf="pralloc.group !== 'ACLevel' && (pralloc.group !== 'ungroupedAllocLabel' || (data.isAllocationGroupEquivalentsRecordsPresent && pralloc.showEquivalents && pralloc.group === 'ungroupedAllocLabel'))">
            <span style="margin-right: 10px;"><a (click)="expandAll()">Expand all</a></span>
            <span style="margin-right: 10px; padding-left: 10px; border-left: 1px solid #CCC"><a (click)="collapseAll()">Collapse all</a></span>
        </div>
        <div class="right" style="margin-left:10px;">Model used for this rebalance: <a (click)="showModelHistoryInRebalance()">{{data.historyModelName}}</a>&nbsp;<i class="pi pi-clone irb-blue clickable" style="font-size: 10px;" (click)="showModelHistoryInRebalance()"></i></div>
        <br class="clear"/>
    </div>
    <div class="pr-grid right" style="width: 100%;">
        <irb-inventory-grid *ngIf="!isUnitTest"
            [style.width] = "'100%'"
                            [gridHeight] = "gridHeight"
                            [showSideBar] = "true"
            [gridOptions] = "gridOptions"
            [domLayout]="domLayout"
            [componentName]="componentName"
            [frameworkComponents] = 'frameworkComponents'
                            [rowData] = 'snapShotData.pfSecRebalDTOList'
            (gridReady) = "onGridReady($event)"
                            (columnVisible) = 'onColumnVisible($event)'
            [popupParent]="popupParent"></irb-inventory-grid>
    </div>
        <div>
        <div class="left" style="margin-top: 5px;">
            <div class="note hblock" *ngIf="data.isAllocationGroupEquivalentsRecordsPresent && pralloc.group === 'ungroupedAllocLabel'"><i>Split</i> indicates an equivalent allocated to multiple parents.</div>
            <div class="note hblock" *ngIf="data.isAllocationExcludedPositionRecordsPresent">* Positions are excluded from the rebalance (options, short positions or excluded restriction type).</div>
            <div class="note hblock" *ngIf="data.isAllocationExcludedPositionRecordsPresent">** Equivalent information is not shown for unheld security purchases.</div>
            <div class="note hblock" *ngIf="pralloc.group === 'ACLevel'"><span class="icon-multi" style="margin-right: 5px"></span>indicates a multi asset-class security.</div>
        </div>
        <div class="right">
            <div class="ag-primary-cols-reset-header-panel" (click)="resetGridColumns()">
                <div class="resetIcon"></div>
                <div class="resetText">Reset columns</div>
            </div>
        </div>
        <br class="clear"/>
    </div>
    <irb-common-dialog #dialogPrComAlloc></irb-common-dialog>
</div>

<ng-template #comPrAllocationTemplate>
    <span [innerHTML]="comPrAllocationTemplateContent"></span>
</ng-template>
<ng-template #securityTradeActionNoteTemplate>
    <span [innerHTML]="securityTradeActionNoteTemplateContent"></span>
</ng-template>
